import React from 'react';
import './App.css';
import DrawingInterface from './components/DrawingInterface';

function App() {
  return (
    <div className="App">
      <DrawingInterface />
    </div>
  );
}

export default App;
